import { ResourceEnum } from "src/constants/constants.ts";
import React from "react";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { AccountingAccountResource } from "@exonn/js-sdk/src/namespaces/accounting-account";

export const module: ModuleOptions<AccountingAccountResource> = {
  resource: ResourceEnum.AccountingAccount,
  bigIcon: <span className={"icon-20-invoices"} />,
  smallIcon: <span className={"icon-15-invoices"} />,
  tabs: {
    edit: {
      titleProp: "account_number",
    },
  },
};
